import { render, staticRenderFns } from "./NotFoundData.vue?vue&type=template&id=770a33e4&scoped=true"
import script from "./NotFoundData.vue?vue&type=script&lang=js"
export * from "./NotFoundData.vue?vue&type=script&lang=js"
import style0 from "./NotFoundData.vue?vue&type=style&index=0&id=770a33e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a33e4",
  null
  
)

export default component.exports